import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Image } from '@zhike/ti-ui';
import { createPromise } from 'utils/action';
import { Error } from '@zhike/ti-component'
import Loading from 'components/loading';
import { handlePractice } from './utils';
import Header from './header';
import Content from './content';
import styles from './styles';

// 报告
export default class Listen extends Component {
  // 参数
  static propTypes = {
    match: PropTypes.object.isRequired,
    getPractice: PropTypes.func.isRequired,
    getUploadSignature: PropTypes.func.isRequired,
    postCorrectionImage: PropTypes.func.isRequired,
    postCorrection: PropTypes.func.isRequired,
    postListen: PropTypes.func.isRequired,
    postListenComplete: PropTypes.func.isRequired,
    postListenReset: PropTypes.func.isRequired,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isCompatible: true,
      isLoad: false,
      practice: {},
      isListen: false,
      listenId: 0,
    };
  }

  // 加载
  async componentWillMount() {
    // 检测兼容性
    if (
      global.navigator.userAgent.match(/msie/i) ||
      global.ActiveXObject ||
      ('ActiveXObject') in global
    ) {
      this.setState({
        isCompatible: false,
      });
    }
    const { getPractice, postListen, match } = this.props;
    const { practiceId } = match.params;
    const search = global.location.search; // eslint-disable-line
    const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const taskId = decodeURIComponent(search.match(new RegExp('[?#&]task_id=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const listen = await createPromise(postListen, {
      practiceId,
      source,
      taskId: taskId || null,
    });
    const practiceData = await createPromise(getPractice, { id: practiceId });
    const practice = handlePractice({
      practice: practiceData,
      listenLimit: 3,
    });
    this.setState({
      isLoad: true,
      practice,
      isListen: listen.data.completion || false,
      listenId: listen.data.id,
    });
  }

  handleFeedback = () => {
    if (this.header) {
      this.header.handleCorrect();
    }
  }

  // 渲染
  render() {
    const { isCompatible, isLoad, practice, isListen, listenId } = this.state;
    const { match, getUploadSignature, postListenComplete, postListenReset,
      postCorrectionImage, postCorrection } = this.props;
    const partId = +match.params.partId || 1;
    const listenParts = practice.listenParts || [];
    const listenPart = listenParts[partId - 1];
    const hasTranslation = listenPart && listenPart.hasTranslation;
    const renderProps = {
      match,
      isListen,
      listenId,
      getUploadSignature,
      postCorrectionImage,
      postCorrection,
      postListenComplete,
      postListenReset,
      ...practice,
      listenParts,
      listenPart,
      hasTranslation,
    };
    return (
      <View className={styles.container} >
        {
          !isCompatible &&
          <Error match={{ params: { type: 'compatible' } }} />
        }
        {
          !isLoad && isCompatible &&
          <Loading text="正在加载数据，请稍候..." />
        }
        {
          isLoad && isCompatible &&
          <Header ref={ref => { this.header = ref; }} {...renderProps} type="listen" />
        }
        {
          isLoad && isCompatible && !listenPart &&
          <View className={[styles.loadingBox, styles.errorContainer]}>
            <Image
              className={styles.loading}
              src={require('components/assets/fail.png')}
            />
            <View className={[styles.text, styles.errorText]}>
              精听资源格式错误，请将问题 <View className={styles.feedback} onClick={this.handleFeedback}>反馈</View> 给我们
            </View>
          </View>
        }
        {
          isLoad && isCompatible && listenPart &&
          <Content {...renderProps} />
        }
      </View>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/listen/index.js